export { default } from './FunctionalTab'
